// eslint-disable-next-line no-restricted-imports
import {
  MutationInput_OrderController_ValidateCreateBody_Input_OperationType,
  ValidateCreateOrderBodyDto_Input,
} from 'api/generated/graphql';
import { ValidateOrderParams } from 'api/types/params';

import { parseCreateOrderParams } from './parseCreateOrderParams';

type ApiParams = Omit<
  ValidateCreateOrderBodyDto_Input,
  'ownerId' | 'ownerType' | 'token'
>;

export const parseValidateOrderParams = (
  params: ValidateOrderParams
): ApiParams => {
  const createParams = parseCreateOrderParams(params);

  return {
    ...createParams,
    operationType:
      MutationInput_OrderController_ValidateCreateBody_Input_OperationType[
        createParams.operationType
      ],
  };
};
